import { AdapterDef } from "../../apis/mgmt/api";
import { DataFormWithButtonsLayout } from "../common/DataFormWithButtonsLayout";
import { EditableProps } from "../common/Editable";
import { AdapterDefForm } from "./AdapterDefForm";


export const AdapterDefEditable = function (
    props: EditableProps<AdapterDef>
) {

    return (
        <DataFormWithButtonsLayout editableProps={props} saveAndStay={true}>
            <AdapterDefForm {...props} />
        </DataFormWithButtonsLayout>
    );

};
